import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AIDevelopment = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="ai-development-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.3s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.3s">
              AI Development
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              <span className="gradient-text">Full-Spectrum Defense </span>
              :<br />
              Safeguarding Your Software Ecosystem
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              Our AI development services are known to unlock the potential of
              vast amounts of data for driving tangible business results. Being
              a renowned AI solutions company, we specialize in leveraging the
              power of AI to transform raw data into actionable insights.
            </p>
          </div>
          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Understanding Your Needs</h3>
                <p>
                  We begin by thoroughly understanding your business objectives
                  and challenges. Our team works closely with you to identify
                  areas where AI can drive value, whether it's automating tasks,
                  enhancing decision-making processes, or improving customer
                  experiences.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Defining Project Scope</h3>
                <p>
                  Once we understand your needs, we define the scope of the AI
                  project. This involves specifying goals, deliverables,
                  timelines, and resource requirements to ensure alignment with
                  your expectations and objectives.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Data Collection and Preparation</h3>
                <p>
                  Data is the lifeblood of AI projects. We collect, clean, and
                  prepare the necessary data to fuel your AI solutions. Our
                  experts ensure that the data is accurate, relevant, and
                  representative to train robust AI models.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Model Development and Training</h3>
                <p>
                  Our skilled data scientists and AI engineers develop custom AI
                  models tailored to your specific requirements. Leveraging
                  advanced algorithms and techniques, we train these models
                  using the prepared data to achieve optimal performance and
                  accuracy.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Testing and Validation</h3>
                <p>
                  Rigorous testing and validation are essential to ensure the
                  reliability and effectiveness of AI solutions. We conduct
                  comprehensive testing to evaluate model performance, identify
                  potential biases, and refine algorithms to meet desired
                  outcomes.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Deployment and Iteration</h3>
                <p>
                  Upon successful testing, we deploy the AI solution into your
                  existing infrastructure or preferred platform. Our support
                  doesn't end there— we monitor performance post-deployment and
                  gather feedback.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">Generative AI</a>
                </li>
                <li>
                  <a href="#section2">AI Product Development</a>
                </li>
                <li>
                  <a href="#section3">AI Security</a>
                </li>
                <li>
                  <a href="#section4">Adaptive AI</a>
                </li>
                <li>
                  <a href="#section5">Natural Language Processing (NLP)</a>
                </li>
                <li>
                  <a href="#section6">Large Language Models (LLM)</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/Generative-AI.jpg"
                    alt="Generative AI"
                  />
                </div>
                <h3>Generative AI</h3>
                <p>
                  As one of the top-rated AI software development companies, we
                  have extensive experience in developing Generative AI
                  solutions with advanced capabilities such as GPT4, GPT3, GPT
                  3.5, Midjourney, and DALL-E.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/AI-Product-Development.jpg"
                    alt="AI Product Development"
                  />
                </div>
                <h3>AI Product Development</h3>
                <p>
                  As a leading custom AI solution provider, we deliver
                  artificial intelligence products using advanced algorithms and
                  techniques. Our custom AI development services drive
                  innovation and improve operational efficiency while ensuring
                  scalability and reliability.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/AI-Security.webp"
                    alt="AI Security"
                  />
                </div>
                <h3>AI Security</h3>
                <p>
                  As an artificial intelligence services company, our AI-enabled
                  data security services are capable of analyzing millions of
                  events and identifying various threats such as malware,
                  vulnerabilities, phishing attacks, and malicious code
                  downloads.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/Adaptive-AI.jpg"
                    alt="Adaptive AI"
                  />
                </div>
                <h3>Adaptive AI</h3>
                <p>
                  Harness the power of adaptive AI to transform your business
                  operations and improve customer satisfaction. With deep
                  expertise in machine learning, deep learning, neural networks,
                  NLP and other AI subsets.
                </p>
              </div>
              <div className="tab-data" id="section5">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/Natural-Language-Processing.jpg"
                    alt="Natural Language Processing (NLP)"
                  />
                </div>
                <h3>Natural Language Processing (NLP)</h3>
                <p>
                  Our team of adaptive AI experts can incorporate Natural
                  Language Processing (NLP) into your application for efficient
                  sentiment analysis, text processing, and named entity
                  recognition.
                </p>
              </div>
              <div className="tab-data" id="section6">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/ai-development/Large-Language-Models.jpg"
                    alt="Large Language Models (LLM)"
                  />
                </div>
                <h3>Large Language Models (LLM)</h3>
                <p>
                  Large language models are AI systems capable of understanding
                  and generating human language by processing vast amounts of
                  text data.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-chatgpt-black.svg"
                  alt="Chatgpt"
                />
              </i>
              <span>Chatgpt</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-claude-ai-black.svg"
                  alt="Claude AI"
                />
              </i>
              <span>Claude AI</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-dall-e.svg"
                  alt="Dall-E"
                />
              </i>
              <span>Dall-E</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-gemini.svg"
                  alt="Gemini"
                />
              </i>
              <span>Gemini</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-midjourny.svg"
                  alt="Midjourney"
                />
              </i>
              <span>Midjourney</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/ai-development/icon-whisper.svg"
                  alt="Whisper"
                />
              </i>
              <span>Whisper</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-python.svg" alt="python" />
              </i>
              <span>Python</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-node-js.svg" alt="node" />
              </i>
              <span>NodeJS</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-java.svg" alt="Java" />
              </i>
              <span>Java</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-javascript.svg"
                  alt="Java Script"
                />
              </i>
              <span>Java Script</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Specialized Expertise</h3>
                <p>
                  Our engineers have specialized expertise in AI technology.
                  They also have skills in a wide range of niches, languages,
                  and tools. We hire only the top 1% of tech talent and bring a
                  high level of expertise to every project.
                </p>
              </div>
              <div>
                <h3>Custom AI Solutions</h3>
                <p>
                  We are a custom software development company that specializes
                  in creating unique solutions across 50+ industry sectors. Our
                  AI models are crafted according to your business objectives
                  and specifications.
                </p>
              </div>
              <div>
                <h3>Result-driven</h3>
                <p>
                  Our strategies are result-driven, focusing on purposeful
                  actions. We strive to achieve impactful outcomes that propel
                  your business forward.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Security</h3>
                <p>
                  We prioritize the utmost security for every Artificial
                  Intelligence services project. Our developers implement robust
                  safety protocols to deliver robust AI software development
                  solutions.
                </p>
              </div>
              <div>
                <h3>Error-free</h3>
                <p>
                  Experience flawless results with our error-free AI services.
                  We design and do rigorous testing to ensure precision and
                  accuracy at every step.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Tailor-made</h3>
                <p>
                  Our tailor-made Artificial intelligence services are
                  meticulously crafted to meet your unique needs. We provide a
                  personalized experience that exceeds expectations.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Specialized Expertise</h3>
              <p>
                Our engineers have specialized expertise in AI technology. They
                also have skills in a wide range of niches, languages, and
                tools. We hire only the top 1% of tech talent and bring a high
                level of expertise to every project.
              </p>
            </div>
            <div>
              <h3>Custom AI Solutions</h3>
              <p>
                We are a custom software development company that specializes in
                creating unique solutions across 50+ industry sectors. Our AI
                models are crafted according to your business objectives and
                specifications.
              </p>
            </div>
            <div>
              <h3>Result-driven</h3>
              <p>
                Our strategies are result-driven, focusing on purposeful
                actions. We strive to achieve impactful outcomes that propel
                your business forward.
              </p>
            </div>
            <div>
              <h3>Security</h3>
              <p>
                We prioritize the utmost security for every Artificial
                Intelligence services project. Our developers implement robust
                safety protocols to deliver robust AI software development
                solutions.
              </p>
            </div>
            <div>
              <h3>Error-free</h3>
              <p>
                Experience flawless results with our error-free AI services. We
                design and do rigorous testing to ensure precision and accuracy
                at every step.
              </p>
            </div>
            <div>
              <h3>Tailor-made</h3>
              <p>
                Our tailor-made Artificial intelligence services are
                meticulously crafted to meet your unique needs. We provide a
                personalized experience that exceeds expectations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-3" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIDevelopment;
